export default {
	game_id: "multi_vegas_81",
	gameName: "Multi Vegas 81",

	stageWidth: 1280,
	stageHeight: 720,

	scripts: [
		"framework/src/vendor/jquery.min.js",
		"framework/src/vendor/tween.js",
		"framework/src/vendor/ph.js",
	],

	infoPages: {
		separated: true,
	},

	game: {
		audio: {
			tracks: [],
		},
		freespins: {
			autostart: true,
		},
		webfonts: ["UbuntuMono-Regular", "Audiowide-Regular"],
	},
	system: {
		audio: {
			tracks: [
				{
					name: 'Jackpot_sound',
					classVol: 'volume.normalWin',
					url: `assets/JokerWinBanner/Jackpot_sound.{ogg,mp3}`,
					loop: false,
				},
				{
					name: 'JokerBonus_alert',
					classVol: 'volume.normalWin',
					url: `assets/JokerWinBanner/JokerBonus_alert.{ogg,mp3}`,
					loop: false,
				},
			],
		},
	},
};
